import addresses from './address.api';
import auth from './auth.api';
import cards from './cards.api';
import cart from './cart.api';
import client from './client.api';
import forms from './forms.api';
import giftCards from './giftCards.api';
import guest from './guest.api';
import locations from './locations.api';
import packages from './packages.api';
import products from './products';
import services from './services.api';

export const api = {
  auth,
  client,
  cards,
  giftCards,
  packages,
  locations,
  services,
  cart,
  addresses,
  products,
  forms,
  guest
};
